import { Reducer } from 'umi';

export interface PeopleModelState {
  update:string[];
  departmentId?:string[];
}

export interface PeopleModelType {
  namespace: 'people';
  state: PeopleModelState;
  reducers: {
    changeDepartmentName: Reducer<PeopleModelState>;
    addUpdate: Reducer<PeopleModelState>;
    removeUpdate: Reducer<PeopleModelState>;
  };
}

const PeopleModel: PeopleModelType = {
  namespace: 'people',
  state: {
    update:[],
    departmentId:[] // 设置成数组让每次更新都能触发，设为string连续设置id不变不触发hooks useRffect
  },
  reducers: {
    changeDepartmentName(state, {payload}) {
      return {
        ...state as PeopleModelState,
        departmentId:[payload.departmentId]
      }
    },
    addUpdate(state, {update}) {
      const tempUpdate = [...state?state.update:[]];
      const key = tempUpdate.indexOf(update);
      if(key<0) {
        tempUpdate.push(update);
      }
      return {
        ...state,
        update:tempUpdate,
      };
    },
    removeUpdate(state, {update}) {
      const tempUpdate = [...state?state.update:[]];
      const key = tempUpdate.indexOf(update);
      if(key>=0) {
        tempUpdate.splice(key,1);
      }
      return {
        ...state,
        update:tempUpdate,
      };
    }  
  },
};

export default PeopleModel;
